import { render, staticRenderFns } from "./ReporteEstadoPptoEgresosView.vue?vue&type=template&id=6a37f266&"
import script from "./ReporteEstadoPptoEgresosView.vue?vue&type=script&lang=js&"
export * from "./ReporteEstadoPptoEgresosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports